import { render, staticRenderFns } from "./ChannelPartnerReview.vue?vue&type=template&id=503cff0c&"
import script from "./ChannelPartnerReview.vue?vue&type=script&lang=js&"
export * from "./ChannelPartnerReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports